// extracted by mini-css-extract-plugin
module.exports = {"peopleInput":"mIVvmbpqWt57_lcotis4J"};